export const CITIES = [
  // Major Indian Cities
  "Mumbai",
  "Delhi",
  "Bangalore",
  "Hyderabad",
  "Ahmedabad",
  "Chennai",
  "Kolkata",
  "Surat",
  "Pune",
  "Jaipur",
  "Lucknow",
  "Kanpur",
  "Nagpur",
  "Indore",
  "Thane",
  "Bhopal",
  "Visakhapatnam",
  "Pimpri-Chinchwad",
  "Patna",
  "Vadodara",
  "Ghaziabad",
  "Ludhiana",
  "Agra",
  "Nashik",
  "Faridabad",
  "Meerut",
  "Rajkot",
  "Kalyan-Dombivali",
  "Vasai-Virar",
  "Varanasi",
  "Srinagar",
  "Aurangabad",
  "Dhanbad",
  "Amritsar",
  "Navi Mumbai",
  "Allahabad",
  "Ranchi",
  "Howrah",
  "Coimbatore",
  "Jabalpur",
  "Gwalior",
  "Vijayawada",
  "Jodhpur",
  "Madurai",
  "Raipur",
  "Kota",
  "Chandigarh",
  "Guwahati",
  "Solapur",
  "Hubli-Dharwad",
  "Tiruchirappalli",
  "Bareilly",
  "Mysore",
  "Tiruppur",
  "Gurgaon",
  "Aligarh",
  "Jalandhar",
  "Bhubaneswar",
  "Salem",
  "Warangal",
  "Guntur",
  "Bhiwandi",
  "Saharanpur",
  "Gorakhpur",
  "Bikaner",
  "Amravati",
  "Noida",
  "Jamshedpur",
  "Bhilai",
  "Cuttack",
  "Firozabad",
  "Kochi",
  "Nellore",
  "Bhavnagar",
  "Dehradun",
  "Durgapur",
  "Asansol",
  "Rourkela",
  "Nanded",
  "Kolhapur",
  "Ajmer",
  "Akola",
  "Gulbarga",
  "Jamnagar",
  "Ujjain",
  "Loni",
  "Siliguri",
  "Jhansi",
  "Ulhasnagar",
  "Jammu",
  "Sangli-Miraj",
  "Mangalore",
  "Erode",
  "Belgaum",
  "Ambattur",
  "Tirunelveli",
  "Malegaon",
  "Gaya",
  "Jalgaon",
  "Udaipur",
  "Maheshtala",
  "Davanagere",
  "Kozhikode",
  "Kurnool",
  "Rajpur Sonarpur",
  "Rajahmundry",
  "Bokaro",
  "South Dumdum",
  "Bellary",
  "Patiala",
  "Gopalpur",
  "Agartala",
  "Bhagalpur",
  "Muzaffarnagar",
  "Bhatpara",
  "Panihati",
  "Latur",
  "Dhule",
  "Rohtak",
  "Korba",
  "Bhilwara",
  "Berhampur",
  "Muzaffarpur",
  "Ahmednagar",
  "Mathura",
  "Kollam",
  "Avadi",
  "Kadapa",
  "Kamarhati",
  "Sambalpur",
  "Bilaspur",
  "Shahjahanpur",
  "Satara",
  "Bijapur",
  "Rampur",
  "Shivamogga",
  "Chandrapur",
  "Junagadh",
  "Thrissur",
  "Alwar",
  "Bardhaman",
  "Kulti",
  "Kakinada",
  "Nizamabad",
  "Parbhani",
  "Tumkur",
  "Khammam",
  "Ozhukarai",
  "Bihar Sharif",
  "Panipat",
  "Darbhanga",
  "Bally",
  "Aizawl",
  "Dewas",
  "Ichalkaranji",
  "Karnal",
  "Bathinda",
  "Jalna",
  "Eluru",
  "Kirari Suleman Nagar",
  "Barabanki",
  "Purnia",
  "Satna",
  "Mau",
  "Sonipat",
  "Farrukhabad",
  "Sagar",
  "Durg",
  "Imphal",
  "Ratlam",
  "Hapur",
  "Arrah",
  "Karimnagar",
  "Anantapur",
  "Etawah",
  "Ambernath",
  "North Dumdum",
  "Bharatpur",
  "Begusarai",
  "New Delhi",
  "Gandhidham",
  "Baranagar",
  "Tiruvottiyur",
  "Puducherry",
  "Sikar",
  "Thoothukudi",
  "Rewa",
  "Mirzapur",
  "Raichur",
  "Pali",
  "Ramagundam",
  "Silchar",
  "Orai",
  "Tonk",
  "Ramgarh",
  "Vizianagaram",
  "Katihar",
  "Machilipatnam",
  "Shimoga",
  "Adoni",
  "Tenali",
  "Proddatur",
  "Saharsa",
  "Hindupur",
  "Sasaram",
  "Hajipur",
  "Bhimavaram",
  "Dehri",
  "Madanapalle",
  "Siwan",
  "Bettiah",
  "Guntakal",
  "Srikakulam",
  "Motihari",
  "Dharmavaram",
  "Gudivada",
  "Narasaraopet",
  "Bagaha",
  "Miryalaguda",
  "Tadipatri",
  "Kishanganj",
  "Karaikudi",
  "Suryapet",
  "Jamalpur",
  "Kavali",
  "Tadepalligudem",
  "Amaravati",
  "Buxar",
  "Jehanabad",
  
  // Major World Cities
  // United States
  "New York",
  "Los Angeles",
  "Chicago",
  "Houston",
  "Phoenix",
  "Philadelphia",
  "San Antonio",
  "San Diego",
  "Dallas",
  "San Jose",
  "Austin",
  "Jacksonville",
  "Fort Worth",
  "Columbus",
  "Charlotte",
  "San Francisco",
  "Indianapolis",
  "Seattle",
  "Denver",
  "Washington",
  "Boston",
  "El Paso",
  "Nashville",
  "Detroit",
  "Oklahoma City",
  "Portland",
  "Las Vegas",
  "Memphis",
  "Louisville",
  "Baltimore",
  "Milwaukee",
  "Albuquerque",
  "Tucson",
  "Fresno",
  "Sacramento",
  "Mesa",
  "Kansas City",
  "Atlanta",
  "Long Beach",
  "Colorado Springs",
  "Raleigh",
  "Miami",
  "Virginia Beach",
  "Omaha",
  "Oakland",
  "Minneapolis",
  "Tulsa",
  "Arlington",
  "Tampa",
  "New Orleans",

  // Canada
  "Toronto",
  "Montreal",
  "Vancouver",
  "Calgary",
  "Edmonton",
  "Ottawa",
  "Winnipeg",
  "Quebec City",
  "Hamilton",
  "Kitchener",
  "London",
  "Victoria",
  "Halifax",
  "Oshawa",
  "Windsor",
  "Saskatoon",
  "St. Catharines",
  "Regina",
  "Sherbrooke",
  "Barrie",

  // United Kingdom
  "London",
  "Birmingham",
  "Leeds",
  "Glasgow",
  "Sheffield",
  "Bradford",
  "Edinburgh",
  "Liverpool",
  "Manchester",
  "Bristol",
  "Wakefield",
  "Cardiff",
  "Coventry",
  "Nottingham",
  "Leicester",
  "Sunderland",
  "Belfast",
  "Newcastle upon Tyne",
  "Brighton",
  "Hull",
  "Plymouth",
  "Stoke-on-Trent",
  "Wolverhampton",
  "Derby",
  "Swansea",
  "Southampton",
  "Salford",
  "Aberdeen",
  "Westminster",
  "Portsmouth",

  // Germany
  "Berlin",
  "Hamburg",
  "Munich",
  "Cologne",
  "Frankfurt am Main",
  "Stuttgart",
  "Düsseldorf",
  "Dortmund",
  "Essen",
  "Leipzig",
  "Bremen",
  "Dresden",
  "Hanover",
  "Nuremberg",
  "Duisburg",
  "Bochum",
  "Wuppertal",
  "Bielefeld",
  "Bonn",
  "Münster",

  // France
  "Paris",
  "Marseille",
  "Lyon",
  "Toulouse",
  "Nice",
  "Nantes",
  "Strasbourg",
  "Montpellier",
  "Bordeaux",
  "Lille",
  "Rennes",
  "Reims",
  "Le Havre",
  "Saint-Étienne",
  "Toulon",
  "Angers",
  "Grenoble",
  "Dijon",
  "Nîmes",
  "Aix-en-Provence",

  // China
  "Shanghai",
  "Beijing",
  "Chongqing",
  "Tianjin",
  "Guangzhou",
  "Shenzhen",
  "Wuhan",
  "Dongguan",
  "Chengdu",
  "Nanjing",
  "Foshan",
  "Shenyang",
  "Hangzhou",
  "Xi'an",
  "Harbin",
  "Suzhou",
  "Qingdao",
  "Dalian",
  "Zhengzhou",
  "Jinan",

  // Japan
  "Tokyo",
  "Yokohama",
  "Osaka",
  "Nagoya",
  "Sapporo",
  "Fukuoka",
  "Kobe",
  "Kawasaki",
  "Kyoto",
  "Saitama",
  "Hiroshima",
  "Sendai",
  "Kitakyushu",
  "Chiba",
  "Sakai",
  "Niigata",
  "Hamamatsu",
  "Okayama",
  "Sagamihara",
  "Kumamoto",

  // South Korea
  "Seoul",
  "Busan",
  "Incheon",
  "Daegu",
  "Daejeon",
  "Gwangju",
  "Suwon",
  "Ulsan",
  "Changwon",
  "Goyang",

  // Australia
  "Sydney",
  "Melbourne",
  "Brisbane",
  "Perth",
  "Adelaide",
  "Gold Coast",
  "Newcastle",
  "Canberra",
  "Sunshine Coast",
  "Wollongong",

  // Brazil
  "São Paulo",
  "Rio de Janeiro",
  "Brasília",
  "Salvador",
  "Fortaleza",
  "Belo Horizonte",
  "Manaus",
  "Curitiba",
  "Recife",
  "Goiânia",

  // Russia
  "Moscow",
  "Saint Petersburg",
  "Novosibirsk",
  "Yekaterinburg",
  "Nizhny Novgorod",
  "Kazan",
  "Chelyabinsk",
  "Omsk",
  "Samara",
  "Rostov-on-Don",

  // Mexico
  "Mexico City",
  "Guadalajara",
  "Monterrey",
  "Puebla",
  "Tijuana",
  "León",
  "Juárez",
  "Torreón",
  "Querétaro",
  "San Luis Potosí",

  // Other Major World Cities
  "Istanbul",
  "Lagos",
  "Kinshasa",
  "Lima",
  "Bangkok",
  "Seoul",
  "London",
  "Tehran",
  "Bogotá",
  "Ho Chi Minh City",
  "Hong Kong",
  "Singapore",
  "Riyadh",
  "Baghdad",
  "Santiago",
  "Surat",
  "Madrid",
  "Suzhou",
  "Pune",
  "Harbin",
  "Houston",
  "Dallas",
  "Toronto",
  "Dar es Salaam",
  "Miami",
  "Belo Horizonte",
  "Singapore",
  "Philadelphia",
  "Atlanta",
  "Fukuoka",
  "Khartoum",
  "Barcelona",
  "Johannesburg",
  "Saint Petersburg",
  "Qingdao",
  "Dalian",
  "Washington",
  "Yangon",
  "Alexandria",
  "Jinan",
  "Guadalajara",

  // Middle East & Africa
  "Cairo",
  "Lagos",
  "Kinshasa",
  "Luanda",
  "Nairobi",
  "Mogadishu",
  "Rabat",
  "Addis Ababa",
  "Cape Town",
  "Casablanca",
  "Algiers",
  "Tunis",
  "Dubai",
  "Abu Dhabi",
  "Doha",
  "Kuwait City",
  "Manama",
  "Muscat",
  "Amman",
  "Beirut",
  "Damascus",
  "Jerusalem",
  "Tel Aviv",

  // Europe
  "Rome",
  "Milan",
  "Naples",
  "Turin",
  "Palermo",
  "Genoa",
  "Amsterdam",
  "Rotterdam",
  "The Hague",
  "Utrecht",
  "Vienna",
  "Graz",
  "Linz",
  "Brussels",
  "Antwerp",
  "Ghent",
  "Prague",
  "Brno",
  "Copenhagen",
  "Aarhus",
  "Helsinki",
  "Espoo",
  "Athens",
  "Thessaloniki",
  "Budapest",
  "Debrecen",
  "Dublin",
  "Cork",
  "Warsaw",
  "Kraków",
  "Łódź",
  "Wrocław",
  "Poznań",
  "Lisbon",
  "Porto",
  "Bucharest",
  "Cluj-Napoca",
  "Stockholm",
  "Gothenburg",
  "Malmö",
  "Zurich",
  "Geneva",
  "Basel",
  "Oslo",
  "Bergen",
  "Belgrade",
  "Novi Sad",

  // South America
  "Buenos Aires",
  "Córdoba",
  "Rosario",
  "La Paz",
  "Santa Cruz",
  "Santiago",
  "Valparaíso",
  "Bogotá",
  "Medellín",
  "Cali",
  "Quito",
  "Guayaquil",
  "Asunción",
  "Lima",
  "Arequipa",
  "Montevideo",
  "Caracas",
  "Maracaibo",

  // Asia Pacific
  "Jakarta",
  "Surabaya",
  "Bandung",
  "Bekasi",
  "Medan",
  "Tangerang",
  "Depok",
  "Semarang",
  "Palembang",
  "Makassar",
  "Kuala Lumpur",
  "George Town",
  "Ipoh",
  "Shah Alam",
  "Manila",
  "Quezon City",
  "Caloocan",
  "Davao",
  "Cebu City",
  "Bangkok",
  "Nonthaburi",
  "Pak Kret",
  "Hat Yai",
  "Hanoi",
  "Ho Chi Minh City",
  "Haiphong",
  "Can Tho",
  "Colombo",
  "Dehiwala-Mount Lavinia",
  "Moratuwa",
  "Dhaka",
  "Chittagong",
  "Sylhet",
  "Khulna",
  "Kathmandu",
  "Pokhara",
  "Lalitpur",
  "Thimphu",
  "Malé",

  "Others"
];
